import { Size, Scale, CreateElement } from "../.././MyHelpers";
import { MyCanvas } from "../MyCanvas";
import { SlotGameMessages } from "../SlotGameScreenMessages";
import { SlotSymbol } from "../SlotSymbol";
import { SlotSymbolSprite } from "../SlotSymbolSprite";
import { IPaytable } from "./IPayTable";
import { IPaytableParams } from "./IPayTableFactory";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { Settings } from "../../Settings";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { SymbolsCollectionResources } from "../SpineSymbols/SymbolsCollection";

export interface  Combination
{
	readonly Count: number;
	readonly WinCredits: number;
}

export interface  PaytablePerSymbol
{
	readonly Combinations: Combination [];
	readonly Symbol: SlotSymbol;
}

export class PayTable implements IPaytable {

	protected paytable :PaytablePerSymbol[] = [];
	protected view: HTMLElement = null;
	// symbolSpriteAnims: SlotSymbolSprite[]
	//protected canvas: MyCanvas[] = [];
	protected viewSize: Size;
	protected cash : Map<number,Map<number,HTMLElement>> = new Map<number,Map<number,HTMLElement>>();
	protected symbolSpriteAnims: SlotSymbolSprite[] = [];


	protected symbolSize: Size = new Size(Scale.W(150), Scale.H(150));
	protected nameGame : string ;
	protected gamePath : string;
	readonly symbolsCollection : Map<string,SymbolsCollectionResources> = null;

	constructor(paytable :PaytablePerSymbol[],paytableParams : IPaytableParams)
	{
		this.viewSize = paytableParams.viewSize;
		this.paytable = paytable;
		this.symbolSpriteAnims = paytableParams.symbolSpriteAnims;
		this.nameGame = paytableParams.nameGame;
		this.gamePath = Settings.ResourcesFolder + "multigame/slot/" + this.nameGame + "/resources/";
		this.symbolsCollection = paytableParams.symbolsCollection;



		this.view = CreateElement("div", {
			classes: ["paytable"],
			//parentToAppend: this.view,
			style: {
				position: "absolute",
				width: Scale.Wpx(1800),
				height: Scale.Hpx(864),
				display: "flex",
				alignContent: "center",
				alignItems: "center",
				fontFamily: "NotoSansDisplay-Regular",


			}
		});

		//this.view = document.createElement("div");
		//.view.classList.add("paytable");

		//this.view.style.width = this.viewSize.width+ "px";
		//this.view.style.height = "400px";

		//this.view.style.backgroundColor = "black";

		//this.BuildPaytable();

	}
	OnResize(): unknown {
		throw new Error("Method not implemented.");
	}
	Build(): void {
		throw new Error("Method not implemented.");
	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		resourceManager.AddGlobal(new ImageResource(this.gamePath + "paytable.png", ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background"]).Scope()));
	}

	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.BuildPaytable(resourceManager);
	}

	public BuildPaytable(resourceManager : IReadOnlyResourceManager): void {

		let PaytableSymbolsContainer = CreateElement("div", {
			classes: ["paytable-symbols-container"],
			parentToAppend: this.view,
			style: {
				display: "flex",
				flexDirection: "row",
				flexWrap: "wrap",
				justifyContent: "space-evenly",

			}
		});





		//let r =null// `<div class="paytable-symbols-container">`;
		for (let si = 0; si < this.paytable.length; si++) {

			//CHANGE FOR CODE
			//r +=  `<div class="paytable-symbol-container">`;

			let PaytableSymbolContainer = CreateElement("div", {
				classes: ["paytable-symbol-container"],
				parentToAppend: PaytableSymbolsContainer,
				style: {
					//width: Scale.Wpx(384),
					display: "flex",
					justifyContent: "space-evenly",
					padding: Scale.XYpx(10),
					width: (Scale.W(1536) / 6) - Scale.W(20) + "px",
					margin: Scale.XYpx(10),
					backgroundColor: "rgba(0, 0, 0, 0)",
					borderRadius: Scale.XYpx(25),
					flexGrow: Scale.XYpx(1),
					backgroundImage: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background"]).Scope()).CssBackground(),
					backgroundSize: "contain",
					backgroundRepeat: "no-repeat",
					backgroundPosition: "center",

				}
			});
			//CHANGE FOR CODE					
			// let r =    `<div class="symbol paytable-symbol-${si}">`;
			let symbol = CreateElement("div", {
				classes: ["symbol", "paytable-symbol-" + si.toString()],
				parentToAppend: PaytableSymbolContainer,
				style: {
					width: Scale.Wpx(320),
					//padding: 20px,
					height: "auto",
					//min-height: 175px,
					position: "relative",
					//border: 1px solid red,
					display: "flex",
					//margin: 0px 0px 30px 0px,					

				}
			});

			// let r =        `<div class="paytable-symbol-image image"></div>`;


			let PaytableSymbolImage = CreateElement("div", {
				classes: ["paytable-symbol-image", "image"],
				parentToAppend: symbol,
				style: {
					flexGrow: "0",
					flexShrink: "0",
					width: Scale.Wpx(150),
					height: Scale.Hpx(150),
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					marginTop: Scale.Ypx(5),
					marginBottom: Scale.Ypx(5),
					marginLeft: Scale.Xpx(7),
					marginRight: Scale.Xpx(19),
					//width: 200px;
					//height: 200px;
					//border: 1px solid red;




				}
			});
			//let r =`<div class="paytable-combinations">`;

			let PaytableCombinations = CreateElement("div", {
				classes: ["paytable-combinations"],
				parentToAppend: symbol,
				style: {
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					position: "absolute",
					left: Scale.Xpx(160),
					top: Scale.Ypx(27),
					fontFamily: "Arial",
					fontWeight: "normal",
				}
			});



			let combinations = this.paytable[si].Combinations;
			for (let ci = 0; ci < combinations.length; ci++) {
				//let r =        `<div class="paytable-combination paytable-combination-${ci}">`;

				let PaytableCombination = CreateElement("div", {
					classes: ["paytable-combination", "paytable-combination-" + ci],
					parentToAppend: PaytableCombinations,
					style: {
						display: "flex",
						flexDirection: "row",
						fontWeight: "bold",
						alignItems: "center",
						verticalAlign: "middle",
						textShadow: " 0px 0px 5px black,0px 0px 10px black,0px 0px 15px black,0px 0px 40px black",
					}
				});






				//let	r =            `<div class="paytable-occurence">${combinations[ci].Count}x</div>`;

				let PaytableOcurrence = CreateElement("div", {
					classes: ["paytable-occurence"],
					parentToAppend: PaytableCombination,
					style: {
						fontSize: Scale.fhpx(25),
						color: " #f49b42",
						width: Scale.Wpx(30),
						textAlign: "left",
					}
				});

				PaytableOcurrence.innerText = combinations[ci].Count.toString() + "x";


				//let	 r =            `<div class="paytable-reward">${combinations[ci].Multiplier}</div>`;
				//r +=        `</div>`;


				let PaytableReward = CreateElement("div", {
					classes: ["paytable-reward"],
					parentToAppend: PaytableCombination,
					style: {
						fontSize: Scale.fhpx(18),
						color: " white",
						marginBottom: Scale.Ypx(2),
						position: "absolute",
						left: Scale.Xpx(35),
						flexGrow: Scale.fh(1).toString(),
						textAlign: "rigth",
					}
				});

				PaytableReward.innerText = combinations[ci].WinCredits.toString();
			}
			//r +=        `</div>`;
			//r +=    `</div>`;
			//r +=  `</div>`;				
		}
		//r += `</div>`;

		//PaytableSymbolsContainer.append(PaytableSymbolContainer) ;


		for (let si = 0; si < this.paytable.length; si++) {
			let symboleCash: Map<number, HTMLElement> = new Map<number, HTMLElement>();

			let combinations = this.paytable[si].Combinations;
			for (let ci = 0; ci < combinations.length; ci++) {
				symboleCash.set(ci, this.view.querySelector(`.paytable-symbol-${si} .paytable-combination-${ci} .paytable-reward`));
			}
			this.cash.set(si, symboleCash);
		}

		for (let si = 0; si < this.paytable.length; si++) {
			let imgHTML = this.symbolsCollection.get("Symbol_" + this.paytable[si].Symbol.ID).imgResource.cloneNode(true) as HTMLSpanElement;
			imgHTML.style.width = this.symbolSize.Width + "px";
			imgHTML.style.height = this.symbolSize.Height + "px";
			this.view.querySelector(".paytable-symbol-" + si + " .image").appendChild(imgHTML);
		}


	}

	public SetBet(message: SlotGameMessages.BetChange)
	{
		let bet = message.bet;
		let totalBet = message.betTotalCredit;

		for (let si = 0 ; si< this.paytable.length ; si++) 
        {
			let symbol = this.cash.get(si);

			let combinations = this.paytable[si].Combinations;
			for (let ci = 0; ci < combinations.length; ci++) 
            {
				let c = symbol.get(ci);
				if(this.paytable[si].Symbol.SymbolType == "Scatter")
				{
					c.innerHTML = ""+(combinations[ci].WinCredits * totalBet);
				}
				else
				{
					c.innerHTML = ""+(combinations[ci].WinCredits * bet);
				}
				
				

			}
		}

	}


	public Update(force: boolean = false):void
	{
		// for(let si = 0; si< this.paytable.length ; si++ )
		// {
		// 	let i: number = this.paytable[si].Symbol.Index;
		// 	if (this.symbolSpriteAnims[i].Sprite().FrameChanged() || this.canvas[si].WasContextLost() || force)
		// 	{
		// 		this.canvas[si].RestoreContext();
		// 		this.symbolSpriteAnims[i].Draw(this.canvas[si]);
		// 	}
		// }
	}
	
	public View():HTMLElement
	{
		return this.view;
	}

	public StartAnim(){

	}

	public StopAnim(){
		
	}
}
